import React, { useEffect, useState } from "react";
import {
  ViedocButtonElement,
  ViedocDialogElement,
  ViedocMenuItemElement,
  ViedocSelectElement,
  ViedocTextareaElement,
} from "../../../../../secure/elements/ViedocReactElements";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../shared/Loader/Loader";
import * as templateActions from "../../../../../store/actions/templateActions";
import _ from "underscore";
import { getMilestoneGroupLabel } from "../../../../../../utils/utilsHelper";

const IndividualMilestone = ({
  type,
  milestoneInfo,
  setIsIndividualMilestoneVisible,
  setIsAddMilestoneVisible,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    milestoneGroupList,
    isEditLoading,
    milestoneActionFail,
    mileStoneLastModified,
    tmfStructureData,
    errorFields,
  } = useSelector((store) => store.template);

  const { isMilestoneViewLoading, artifactCount, artifactList } = useSelector(
    (store) => store.document
  );

  const addModeMilestoneGroupList = [
    ...milestoneGroupList.result,
    t("ADMIN.TEXT_SELECTGROUP"),
  ];
  const SpanFunc = () => {
    return <span style={{ color: "#CC4E00" }}>*</span>;
  };
  const [selectedGroup, setSelectedGroup] = useState(
    type === "add" ? t("ADMIN.TEXT_SELECTGROUP") : milestoneInfo.group
  );

  const [trialDescription, setTrialDescription] = useState(
    type === "add" ? "" : milestoneInfo.trialDescription
  );
  const [countryDescription, setCountryDescription] = useState(
    type === "add" ? "" : milestoneInfo.countryDescription
  );
  const [siteDescription, setSiteDescription] = useState(
    type === "add" ? "" : milestoneInfo.siteDescription
  );
  const [selectedIdentifier, setSelectedIdentifier] = useState(
    type === "add" ? "" : milestoneInfo.identifier
  );
  const [selectedName, setSelectedName] = useState(
    type === "add" ? "" : milestoneInfo.name
  );

  const [isTouched, setIsTouched] = useState(false);
  const [showList, setShowList] = useState(false);
  const [showToaster, setShowToaster] = useState(false);
  const [showWarnings, setShowWarnings] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);

  const descriptionArray = [
    {
      id: 1,
      label: "trial-desc",
      placeholder: t("ADMIN.TABLEHEADER_TRIALDESCRIPTION"),
      value: trialDescription,
    },
    {
      id: 2,
      label: "country-desc",
      placeholder: t("ADMIN.TABLEHEADER_COUNTRYDESCRIPTION"),
      value: countryDescription,
    },
    {
      id: 3,
      label: "site-desc",
      placeholder: t("ADMIN.TABLEHEADER_SITEDESCRIPTION"),
      value: siteDescription,
    },
  ];

  useEffect(() => {
    !_.isEmpty(milestoneActionFail) && setShowToaster(true);
    if (_.isEmpty(milestoneActionFail) && !isEditLoading && !initialLoad) {
      type === "add"
        ? setIsAddMilestoneVisible(false)
        : setIsIndividualMilestoneVisible(false);
      setInitialLoad(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [milestoneActionFail, isEditLoading]);

  useEffect(() => {
    if (
      selectedGroup === milestoneInfo.group &&
      selectedIdentifier === milestoneInfo.identifier &&
      selectedName === milestoneInfo.name &&
      trialDescription === milestoneInfo.trialDescription &&
      countryDescription === milestoneInfo.countryDescription &&
      siteDescription === milestoneInfo.siteDescription
    ) {
      setIsTouched(false);
    }

    if (
      selectedGroup !== t("ADMIN.TEXT_SELECTGROUP") &&
      selectedIdentifier !== "" &&
      selectedName !== ""
    ) {
      setShowToaster(false);
      setShowWarnings(false);
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedGroup,
    selectedIdentifier,
    selectedName,
    trialDescription,
    countryDescription,
    siteDescription,
  ]);

  const onHide = (e) => {
    e.stopPropagation();
    dispatch(templateActions.addNewMilestoneHideError());
    type === "add"
      ? setIsAddMilestoneVisible(false)
      : setIsIndividualMilestoneVisible(false);
  };

  const renderToaster = (message) => {
    return (
      showToaster && (
        <viedoc-toaster
          onClick={() => setShowToaster(false)}
          variant="error"
          prefix-icon="warning"
          toasterMsg={message}
        ></viedoc-toaster>
      )
    );
  };

  const renderGroupSelect = () => {
    switch (type) {
      case "edit":
        return milestoneGroupList.result.map((group, index) => (
          <ViedocMenuItemElement
            selected={group === selectedGroup ? true : null}
            key={index}
            value={group}
            title=""
          >
            {getMilestoneGroupLabel(group)}
          </ViedocMenuItemElement>
        ));
      case "add":
        return addModeMilestoneGroupList.map((group, index) => (
          <ViedocMenuItemElement
            selected={selectedGroup === group ? true : null}
            hidden={group === t("ADMIN.TEXT_SELECTGROUP")}
            key={index}
            value={group}
            title=""
          >
            {getMilestoneGroupLabel(group)}
          </ViedocMenuItemElement>
        ));
      default:
        break;
    }
  };

  const getLabels = (label) => {
    let newLabel = "";
    switch (label) {
      case "group":
        newLabel = t("ADMIN.TEXT_GROUP");
        break;

      case "id":
        newLabel = t("ADMIN.TABLEHEADER_ID");
        break;

      case "name":
        newLabel = t("ADMIN.TABLEHEADER_NAME");
        break;

      case "trial-desc":
        newLabel = t("ADMIN.TABLEHEADER_TRIALDESCRIPTION");
        break;

      case "country-desc":
        newLabel = t("ADMIN.TABLEHEADER_COUNTRYDESCRIPTION");
        break;

      case "site-desc":
        newLabel = t("ADMIN.TABLEHEADER_SITEDESCRIPTION");
        break;

      default:
        break;
    }
    return newLabel !== t("ADMIN.TEXT_GROUP") &&
      newLabel !== t("ADMIN.TABLEHEADER_ID") &&
      newLabel !== t("ADMIN.TABLEHEADER_NAME") ? (
      newLabel
    ) : (
      <>
        {newLabel}
        <SpanFunc />
      </>
    );
  };

  const fieldArray = [
    {
      id: 1,
      label: "id",
      className: `${
        (showWarnings && _.isEmpty(selectedIdentifier)) ||
        (showToaster && milestoneActionFail && errorFields.includes("Id"))
          ? "id-textfield warning"
          : "id-textfield"
      }`,
      value: selectedIdentifier,
    },
    {
      id: 2,
      label: "name",
      className: `${
        (showWarnings && _.isEmpty(selectedName)) ||
        (showToaster && milestoneActionFail && errorFields.includes("Name"))
          ? "name-textfield warning"
          : "name-textfield"
      }`,
      value: selectedName,
    },
  ];

  const fieldChangeHandler = (event, label) => {
    switch (label) {
      case "id":
        setSelectedIdentifier(event.target.value);
        break;
      case "name":
        setSelectedName(event.target.value);
        break;
      default:
        break;
    }
    setIsTouched(true);
  };

  const renderFieldSelect = () => {
    return (
      <div className="mb-30">
        {fieldArray.map((field) => (
          <div key={field.id}>
            <label>{getLabels(field.label)}</label>
            <viedoc-textfield size="small" class={field.className}>
              <input
                value={field.value}
                onChange={(e) => fieldChangeHandler(e, field.label)}
              />
            </viedoc-textfield>
          </div>
        ))}
      </div>
    );
  };

  const viewFieldArray = [
    {
      id: 1,
      label: "id",
      value: milestoneInfo.identifier,
      className: "id-field",
    },
    {
      id: 2,
      label: "name",
      value: milestoneInfo.name,
      className: "id-field name-field",
    },
  ];
  const renderFieldView = () => {
    return (
      <div className="mb-30 field-select">
        {viewFieldArray.map((field) => (
          <div key={field.id}>
            <label>{getLabels(field.label)}</label>
            <div className={field.className}>
              <p>{field.value}</p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const RenderViewMode = () => {
    return (
      <>
        <label>{getLabels("group")}</label>
        <div className="group-textfield" title={getMilestoneGroupLabel(milestoneInfo.group)}>
          <p>{getMilestoneGroupLabel(milestoneInfo.group)}</p>
        </div>

        {renderFieldView()}
        {renderDescription()}
      </>
    );
  };

  const descriptionHandler = (e, label) => {
    switch (label) {
      case "trial-desc":
        setTrialDescription(e.target.value);
        break;
      case "country-desc":
        setCountryDescription(e.target.value);
        break;
      case "site-desc":
        setSiteDescription(e.target.value);
        break;
      default:
        break;
    }
    setIsTouched(true);
  };

  const renderDescription = () => {
    return descriptionArray.map((description) => (
      <div className="description" key={description.id}>
        <label>{getLabels(description.label)}</label>
        <ViedocTextareaElement
          placeholder={description.placeholder}
          value={description.value}
          disabled={type === "view" ? true : false}
          rows={3}
          onChange={(e) => descriptionHandler(e, description.label)}
        />
      </div>
    ));
  };

  const renderArtifactList = () => {
    return (
      showList && (
        <div className="artifact-list-main">
          {artifactList.map((list) => (
            <div key={list.artifactid} className="artifact-list">
              <div className="icon">
                <viedoc-icon name="link" />
              </div>
              <span className={list.isdeleted ? "line-through" : ""}>
                {list.artifactid + " " + list.artifactname}
              </span>
            </div>
          ))}
        </div>
      )
    );
  };

  const renderArtifactCount = () => {
    return (
      <div className="artifact-count-main">
        <div className="artifact-count">
          <div className="artifact-count-body">
            <div className="badge">
              <span>{artifactCount}</span>
              <p>{t("ADMIN.TEXT_ARTIFACTLINKED")}</p>
            </div>
            <div
              onClick={() => setShowList((prevState) => !prevState)}
              title={
                showList ? t("ADMIN.TEXT_HIDELIST") : t("ADMIN.TEXT_SHOWLIST")
              }
            >
              {artifactCount !== 0 && (
                <>
                  {showList
                    ? t("ADMIN.TEXT_HIDELIST")
                    : t("ADMIN.TEXT_SHOWLIST")}
                </>
              )}
            </div>
          </div>
        </div>
        <div>{renderArtifactList()}</div>
      </div>
    );
  };

  const saveChangesHandler = (e) => {
    if (
      selectedGroup === t("ADMIN.TEXT_SELECTGROUP") ||
      selectedIdentifier === "" ||
      selectedName === ""
    ) {
      setShowToaster(true);
      setShowWarnings(true);
      return;
    }
    let requestPayload = {
      action: milestoneInfo.action,
      countryDescription: countryDescription,
      group: selectedGroup,
      id: milestoneInfo.id,
      identifier: selectedIdentifier,
      isDeleted: milestoneInfo.isDeleted,
      lastModifiedOn: mileStoneLastModified
        ? mileStoneLastModified
        : tmfStructureData.lastmodifiedon,
      name: selectedName,
      order: milestoneInfo.order,
      siteDescription: siteDescription,
      trialDescription: trialDescription,
    };

    type === "add"
      ? dispatch(templateActions.addNewMilestone(requestPayload))
      : dispatch(templateActions.editMilestone(requestPayload));
    dispatch(templateActions.addNewMilestoneHideError());
    setIsTouched(false);
    setInitialLoad(false);
    setShowToaster(false);
  };

  const cancelHandler = (type) => {
    setSelectedGroup(
      type === "add" ? t("ADMIN.TEXT_SELECTGROUP") : milestoneInfo.group
    );
    setSelectedIdentifier(type === "add" ? "" : milestoneInfo.identifier);
    setSelectedName(type === "add" ? "" : milestoneInfo.name);
    setTrialDescription(type === "add" ? "" : milestoneInfo.trialDescription);
    setCountryDescription(
      type === "add" ? "" : milestoneInfo.countryDescription
    );
    setSiteDescription(type === "add" ? "" : milestoneInfo.siteDescription);
    setIsTouched(false);
    setShowWarnings(false);
    setShowToaster(false);
  };

  const deleteMilestoneHandler = (e) => {
    const deletePayload = {
      id: milestoneInfo.id,
      lastModifiedOn: mileStoneLastModified
        ? mileStoneLastModified
        : tmfStructureData.lastmodifiedon,
    };
    dispatch(templateActions.deleteMilestone(deletePayload));
    setInitialLoad(false);
  };

  return (
    <ViedocDialogElement
      size="medium"
      class="individual-milestone-popup"
      open
      preventCloseByClick
      onHide={(e) => onHide(e)}
    >
      <header className="pl-10" slot="header">
        {type === "add" && (
          <p className="f21 mt-5">{`${t("ADMIN.TEXT_ADD")} ${t(
            "ADMIN.TEXT_NEWMILESTONE"
          )}`}</p>
        )}
        {type !== "add" && (
          <p className="f21 mt-5">{`${
            type === "view" ? t("ADMIN.TEXT_VIEW") : t("ADMIN.TEXT_EDIT")
          } '${milestoneInfo.name}'`}</p>
        )}
        {type !== "view" && (
          <div className="header-button">
            <ViedocButtonElement
              size="small"
              variant="neutral"
              disabled={!isTouched}
              onClick={() => cancelHandler(type)}
              title = {t("ADMIN.BUTTON_CANCEL")}
            >
              {t("ADMIN.BUTTON_CANCEL")}
            </ViedocButtonElement>

            <ViedocButtonElement
              size="small"
              variant="neutral"
              disabled={!isTouched}
              onClick={(e) => saveChangesHandler(e)}
              title={type === "add"
                ? t("TMF.REVIEWPOPUP_READY")
                : t("ADMIN.BUTTON_SAVEBTN")}
            >
              {type === "add"
                ? t("TMF.REVIEWPOPUP_READY")
                : t("ADMIN.BUTTON_SAVEBTN")}
            </ViedocButtonElement>
          </div>
        )}
      </header>
      {renderToaster(
        milestoneActionFail ? milestoneActionFail : t("TMF.TOAST_REQUIRED")
      )}
      {isMilestoneViewLoading || isEditLoading ? (
        <Loader width={"100%"} height={"100%"} borderRadius />
      ) : (
        <>
          <div className="individual-milestone">
            <div className="individual-milestone-body">
              {type === "view" ? (
                <RenderViewMode />
              ) : (
                <>
                  <label>{getLabels("group")}</label>
                  <ViedocSelectElement
                    size="small"
                    value={selectedGroup}
                    className="group-select"
                    disabled={type === "view" ? true : false}
                    onChange={(e) => {
                      setIsTouched(true);
                      setSelectedGroup(e.target.value);
                    }}
                    title={selectedGroup}
                  >
                    {renderGroupSelect()}
                  </ViedocSelectElement>
                  {renderFieldSelect()}
                  {renderDescription()}
                </>
              )}
            </div>
          </div>
          {type !== "add" && renderArtifactCount()}
          {type !== "edit" && <footer slot="footer"></footer>}
          {type === "edit" && (
            <footer slot="footer" className="milestone-footer">
              <div className="milestone-footer-body">
                <ViedocButtonElement
                  size="medium"
                  disabled={artifactCount !== 0}
                  title={
                    artifactCount !== 0
                      ? t("ADMIN.TEXT_DELETEMILESTONELINKEDMESSAGE")
                      : t("ADMIN.ADMINTAB_DELETEMILESTONE")
                  }
                  variant={artifactCount !== 0 ? "neutral" : "error"}
                  onClick={(e) => deleteMilestoneHandler(e)}
                >
                  <viedoc-icon name="delete_bin" slot="prefix"></viedoc-icon>
                  <p>{t("ADMIN.ADMINTAB_DELETEMILESTONE")}</p>
                </ViedocButtonElement>
              </div>

              {artifactCount !== 0 && (
                <p>{t("ADMIN.ADMINTAB_MILESTONEWARN")}</p>
              )}
            </footer>
          )}
        </>
      )}
    </ViedocDialogElement>
  );
};

export default IndividualMilestone;
